/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.accordionSection", {
        options: {
            header: "h3",
        },

        _create: function () {
            this.acc = this.element;

            var activeItm = api.fn.getData(this.acc, "active", false);
            var animate = api.fn.getData(this.acc, "animate", 200);

            this.acc.accordion({
                navigation: true,
                animate: animate,
                header: this.options.header,
                heightStyle: "content",
                collapsible: true,
                active: activeItm,
            });
        },
    });
})(jQuery);
